// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.18.1
//   protoc               v3.19.1
// source: xeam/common/permission.proto

/* eslint-disable */

export const protobufPackage = "xeam.common";

export const protobufFileName = "xeam/common/permission.proto";

export enum XitePermission {
  VIEW = 0,
  MANAGE_ENERGY_MODE = 1,
  MANAGE_AWAY = 2,
  MANAGE_SETTINGS = 3,
  MANAGE_GRID_SERVICE = 4,
  MANAGE_SCHEDULER = 5,
  MANAGE_EV_CHARGER = 6,
  MANAGE_ROOMS = 7,
  MANAGE_BUILDINGS = 8,
}

export enum WorkspacePermission {
  VIEW = 0,
  MANAGE_USERS = 1,
  MANAGE_SETTINGS = 2,
  MANAGE_BILLING = 3,
  MANAGE_XITES = 4,
  MANAGE_VEHICLES = 5,
  MANAGE_CHARGERS = 6,
  MANAGE_INDOOR = 7,
}

export enum SuperUserPermission {
  VIEW = 0,
  LOGIN_AS = 1,
  LOGIN_AS_MANAGE = 2,
  MANAGE_PACKAGES = 3,
  MANAGE_XITE_PACKAGES = 4,
}
